import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { setAuthorization } from '../helpers/api_helper'
import { useDispatch } from 'react-redux'

import { useProfile } from '../Components/Hooks/UserHooks'

import { logoutUser } from '../slices/auth/login/thunk'

// Map routes to page permission names
const ROUTE_PAGE_MAP: Record<string, string> = {
  '/sales': 'Sales',
  '/booths': 'Booths',
  '/locations': 'Locations',
  '/services': 'Services',
  '/promotions': 'Promotions',
  '/promotion-booths': 'Promotion Booths',
  '/backgrounds': 'Backgrounds',
  '/background-categories': 'Backgrounds',
  '/effects': 'Effects/Filters',
  '/users': 'Users',
  '/events': 'Events',
  '/event-booths': 'Events',
  '/action-prices': 'Services',
}

// Pages always accessible (no permission check needed)
const ALWAYS_ALLOWED = ['/profile', '/dashboard', '/dashboard-analytics', '/index', '/']

const AuthProtected = (props: any) => {
  const dispatch: any = useDispatch()
  const { userProfile, loading, token } = useProfile()
  const location = useLocation()

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token)
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser())
    }
  }, [token, userProfile, loading, dispatch])

  // Not authenticated
  if (!userProfile && loading && !token) {
    return <Navigate to={{ pathname: '/login' }} />
  }

  // Check page-level permissions for operator users
  const userType = sessionStorage.getItem('userType')
  const isAdmin = userType === '1'
  const currentPath = location.pathname

  if (!isAdmin && !ALWAYS_ALLOWED.includes(currentPath)) {
    const requiredPage = ROUTE_PAGE_MAP[currentPath]
    if (requiredPage) {
      let hasAccess = false
      try {
        const stored = sessionStorage.getItem('userRoles')
        if (stored) {
          const permissions = JSON.parse(atob(stored))
          hasAccess = Array.isArray(permissions) && permissions.some(
            (p: any) => p.page === requiredPage && p.canView
          )
        }
      } catch {}

      if (!hasAccess) {
        // Redirect to first accessible page
        let firstAllowed = '/profile'
        try {
          const stored = sessionStorage.getItem('userRoles')
          if (stored) {
            const permissions = JSON.parse(atob(stored))
            const first = Array.isArray(permissions) && permissions.find((p: any) => p.canView)
            if (first) {
              const routeMap: Record<string, string> = {
                Sales: '/sales', Booths: '/booths', Locations: '/locations',
                Services: '/services', Promotions: '/promotions',
                'Promotion Booths': '/promotion-booths', Backgrounds: '/backgrounds',
                'Effects/Filters': '/effects', Users: '/users'
              }
              firstAllowed = routeMap[first.page] || '/profile'
            }
          }
        } catch {}
        return <Navigate to={firstAllowed} replace />
      }
    }
  }

  return <>{props.children}</>
}

export default AuthProtected
